import React from 'react'
import ContextMenu from './ContextMenu'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import withProps from 'recompose/withProps'

const props = withProps(({ isMobile }) => ({
    theme: isMobile ? styleguide.contextMenu.dark : styleguide.contextMenuDesktop.darkFullLabel,
    width: isMobile ? '4em' : 'auto',
}))

const OverflowContextMenu = ({ options, theme, width }) => (
    <ContextMenu
        style={{
            width,
        }}
        theme={theme}
        options={options}
    />
)

export default compose(props, pure)(OverflowContextMenu)
